import { createInputs } from '../../utils';

const subFields = createInputs([{ name: 'html', type: 'richText', required: true }]);

export default createInputs([
  { name: 'nocheck', type: 'boolean', required: false, friendlyName: 'Masquer les checkbox' },
  { name: 'items', type: 'list', required: true, subFields },
]);
